export enum CardApplicationStatus {
  AcceptFromClient = 1,
  OnReview,
  Accepted,
  Declined,
}
